import { NgModule } from '@angular/core';
import { KrakenProgressIndicatorComponent } from './kraken-progress-indicator.component';
import { CommonModule } from '@angular/common';
import { KrakenTooltipModule } from '@kraken-ui/kraken-tooltip';

@NgModule({
  declarations: [
    KrakenProgressIndicatorComponent
  ],
  imports: [
    CommonModule,
    KrakenTooltipModule
  ],
  exports: [
    KrakenProgressIndicatorComponent
  ]
})
export class KrakenProgressIndicatorModule { }
